import module from 'guest/module.js'

class GuestNominaDocumentoReciboService {
  constructor ($api) {
    this.$api = $api
  }

  link (idProyecto, idColaborador, idNomina) {
    return this.$api.link('/kendu/kardex/nominas/nomina/recibo', {
      id_empresa: idProyecto,
      id_empleado: idColaborador,
      id_nomina: idNomina,
    })
  }
}

module.service('GuestNominaDocumentoRecibo', GuestNominaDocumentoReciboService)



// WEBPACK FOOTER //
// ./src/guest/services/Guest/Nomina/Documento/Recibo.js